export class Hotel {
    username: string;
    password: string;
    hotelname: string;
    contact: number;
    hotelid:number;
    bill_no:any;
    time:any;
    potatoamt:number = 0;
    potato:number = 0;
    potatoqty=0;
    redcabbage=0;
    redcabbageqty = 0;
    redcabbageamt = 0;
    onionqty = 0;
    onionamt = 0
    rypaperqty =0 ;
    tomatoqty = 0
    aspraygusqty = 0
    garlicqty = 0
    awakadoqty = 0
    gingerqty = 0
    bazilqty = 0
    greenchillyqty = 0
    cabbageqty = 0
    lemongrassqty = 0
    lickqty = 0
    cauliflowerqty = 0
    cherrytomatoqty = 0
    beansqty = 0
    pakchoyqty = 0
    cucumberqty = 0
    zukiniqty = 0
    carrotqty= 0 
    chinesscabbageqty = 0
    beetrootqty = 0
    redchillyqty = 0
    brinjalqty = 0
    sweetpotatoqty = 0
    drumstickqty = 0
    icebragqty =0
    pumkingqty = 0
    babycornqty =0
    lemonqty=0
    brokaliqty=0
    capsicumqty =0
    sweetcornqty = 0
    ladyfingerqty = 0
    mushroomqty = 0
    coconutqty = 0
    celeryqty = 0
    spinachqty = 0
    parsleyqty = 0
    corianderqty = 0
    staphvegqty = 0
    springonionqty = 0
    dilleavesqty = 0
    radishqty = 0
    caporlinesqty = 0
    mintqty = 0
    karelaqty = 0
    methiqty = 0
    orangeqty = 0
    curryleavsqty = 0;
    battalegqty = 0;
    tondaliqty = 0;
    arriqty = 0;
    matakiqty = 0;
    rawpapaiqty = 0;
    rawbananaqty = 0;
    rawmangoqty = 0;
    appleqty = 0;
    greenappleqty = 0;
    orangelqty = 0;
    watermilanqty = 0;
    tarbujqty = 0;
    strawberryqty = 0;
    kiriqty = 0;
    anarqty = 0;
    bananaqty = 0;
    grepsqty = 0;
    pineappleqty = 0;
    papaiqty = 0;
    mangoqty = 0;
    grianderqty = 0;
    sarsoqty = 0;
    lalsagqty = 0;
    galangalqty = 0;
    tymqty = 0;
    oreganoqty = 0;
    rajmeryqty = 0;
    rocketqty = 0;
    thairedchillyqty = 0;
    babypotatoqty = 0;


    mushroomamt = 0;
    rypaperamt = 0
    tomatoamt = 0
    aspraygusamt = 0
    garlicamt = 0
    awakadoamt  = 0
    gingeramt = 0
    bazilamt = 0
    greenchillyamt = 0
    lemongrassamt = 0
    cabbageamt = 0
    lickamt = 0
    caulifloweramt = 0
    babypotatoamt=0
    cherrytomatoamt = 0
    beansamt = 0
    pakchoyamt = 0
    cucumberamt = 0
    zukiniamt = 0
    carrotamt = 0
    chinesscabbageamt = 0
    beetrootamt = 0
    redchillyamt = 0
    brinjalamt = 0
    sweetpotatoamt = 0
    drumstickamt = 0
    icebragamt = 0
    pumkingamt = 0
    babycornamt = 0
    lemonamt = 0
    brokaliamt = 0
    capsicumamt = 0
    sweetcornamt = 0
    ladyfingeramt = 0
    coconutamt = 0
    spinachamt=0
    celeryamt = 0
    parsleyamt = 0
    corianderamt = 0
    springonionamt = 0
    staphvegamt = 0
    dilleavesamt = 0
    radishamt = 0
    caporlinesamt = 0
    mintamt = 0 
    karelaamt = 0
    methiamt = 0
    orangeamt = 0
    curryleavsamt = 0;
    battalegamt = 0;
    tondaliamt = 0;
    arriamt = 0;
    matakiamt = 0;
    rawpapaiamt = 0;
    rawbananaamt = 0;
    rawmangoamt = 0;
    appleamt = 0;
    
    greenappleamt = 0;
    orangelamt = 0;
    watermilanamt = 0;
    tarbujamt = 0;
    strawberryamt = 0;
    kiriamt = 0;
    anaramt = 0;
    bananaamt = 0;
    grepsamt = 0;
    pineappleamt = 0;
    papaiamt = 0;
    mangoamt = 0;
    grianderamt = 0;
    sarsoamt = 0;
    lalsagamt = 0;
    galangalamt = 0;
    tymamt = 0;
    oreganoamt = 0;
    rajmeryamt = 0;
    rocketamt = 0;
    thairedchillyamt = 0;
    mat:any;
    tp:any;transport:any=0;
    pending_amount:any;
    total:any;
    fromdate:any;
    todate:any;
    discount:any;


    onion = 0;
    tomato = 0;
    garlic = 0;
    ginger = 0;
    greenchilly = 0;
    cabbage = 0;
    cauliflower = 0;
    beans = 0;
    cucumber = 0;
    carrot = 0;
    beetroot = 0;
    brinjal = 0;
    drumstick = 0;
    pumking = 0;
    battaleg = 0;
    lemon = 0;
    capsicum = 0;
    ladyfinger = 0;
    karela = 0;
    tondali = 0;
    arri = 0;
    mataki = 0;
    sweetpotato = 0;
    redchilly = 0;
    rawpapai = 0;
    rawbanana = 0;
    coconut = 0;
    rawmango = 0;
    spinach = 0;
    griander = 0;
    springonion = 0;
    radish = 0;
    mint = 0;
    methi = 0;
    curryleavs = 0;
    dilleaves = 0;
    sarso = 0;
    lalsag = 0;
    staphveg = 0;
    redCabbage = 0;
    rypaper = 0;
    aspraygus = 0;
    awakado = 0;
    bazil = 0;
    lemongrass = 0;
    lick = 0;
    cherrytomato = 0;
    pakchoy = 0;
    zukini = 0;
    chinesscabbage = 0;
    babypotato = 0;
    icebrag = 0;
    babycorn = 0;
    brokali = 0;
    sweetcorn = 0;
    mushroom = 0;
    celery = 0;
    parsley = 0;
    galangal = 0;
    tym = 0;
    oregano = 0;
    rajmery = 0;
    caporlines = 0;
    rocket = 0;
    thairedchilly = 0;
    mango = 0;
    apple = 0;
    greenapple = 0;
    orange = 0;
    orangel = 0;
    watermilan = 0;
    anar = 0;
    pineapple = 0;
    tarbuj = 0;
    strawberry = 0;
    kiri = 0;
    banana = 0;
    greps = 0;
    papai = 0;

    total_payment = 0;
    paid_amount = 0;
    payment_amount = 0;
    discountamt = 0;
    added_date : string;

    potatounit = 0;
    redcabbageunit = 0;
    onionunit = 0;
    rypaperunit = 0;
    tomatounit = 0;
    aspraygusunit = 0;
    garlicunit = 0;
    awakadounit = 0;
    gingerunit = 0;
    bazilunit = 0;
    greenchillyunit
    lemongrassunit = 0;
    cabbageunit = 0;
    lickunit = 0;
    cauliflowerunit = 0;
    cherrytomatounit = 0;
    beansunit = 0;
    pakchoyunit = 0;
    cucumberunit = 0;
    zukiniunit = 0;
    carrotunit = 0;
    chinesscabbageunit = 0;
    beetrootunit = 0;
    babypotatounit = 0;
    brinjalunit = 0;
    icebragunit = 0;
    drumstickunit = 0;
    babycornunit = 0;
    pumkingunit = 0;
    brokaliunit = 0;
    battalegunit = 0;
    sweetcornunit = 0;
    lemonunit = 0;
    mushroomunit = 0;
    capsicumunit = 0;
    celeryunit = 0;
    ladyfingerunit = 0;
    parsleyunit = 0;
    karelaunit = 0;
    tondaliunit = 0;
    galangalunit = 0;
    arriunit = 0;
    tymunit = 0;
    matakiunit = 0;
    oreganounit = 0;
    sweetpotatounit = 0;
    rajmeryunit = 0;
    redchillyunit = 0;
    caporlinesunit = 0;
    rawpapaiunit = 0;
    rocketunit = 0;
    rawbananaunit = 0;
    thairedchillyunit = 0;
    coconutunit = 0;
    rawmangounit = 0;
    appleunit = 0;
    greenappleunit = 0;
    spinachunit = 0;
    orangeunit = 0;
    grianderunit = 0;
    orangelunit = 0;
    springonionunit = 0;
    watermilanunit = 0;
    radishunit = 0;
    anarunit = 0;
    mintunit = 0;
    pineappleunit = 0;
    methiunit = 0;
    tarbujunit = 0;
    curryleavsunit = 0;
    strawberryunit = 0;
    dilleavesunit = 0;
    kiriunit = 0;
    sarsounit = 0;
    bananaunit = 0;
    lalsagunit = 0;
    grepsunit = 0;
    staphvegunit = 0;
    papaiunit = 0;
    mangounit = 0;

}



// WEBPACK FOOTER //
// D:/xampp/htdocs/tejashree/src/app/hotel.ts